module.exports = __webpack_public_path__ + "media/images/www/company/warehouse-storage-9eca4d1eafed9a59dc5756fec3a97a30.svg";